module.exports = __webpack_public_path__ + "static/logo_white-36bc74ffa113e1063382720458ff5c27.svg";